import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import { enUS, ruRU } from "@mui/x-data-grid/locales";
import * as React from 'react';
import { useEffect } from 'react';
import i18nStore from "./i18n/store";
import authUserStore from "./modules/auth/store";
import projectStore from "./modules/project/store";
import Footer from "./modules/toolbar/Footer";
import MainToolbar from "./modules/toolbar/MainToolbar";


const FooterHeight: any = "50px";
const App = () => {
    const existingTheme = useTheme();
    const [muiGridXTranslations, setMuiGridXTranslations] = React.useState(enUS);

    useEffect(() => {
        authUserStore.prefetchMe();
        projectStore.prefetchData();
    }, []);

    useEffect(() => {
        if (i18nStore.getCurrentLanguageCode === "en") setMuiGridXTranslations(enUS);
        else if (i18nStore.getCurrentLanguageCode === "ru") setMuiGridXTranslations(ruRU);
    }, [i18nStore.getCurrentLanguageCode]);

    const theme = React.useMemo(
        () =>
            createTheme({}, muiGridXTranslations, existingTheme),
        [existingTheme, muiGridXTranslations],
    );

    return (
        <Box sx={{position: "relative", minHeight: "100vh"}}>
            <Box sx={{p: 0, m: 0, pb: FooterHeight}}>
                <ThemeProvider theme={theme}>
                    <MainToolbar/>
                </ThemeProvider>
            </Box>
            <Footer FooterHeight={FooterHeight}/>
        </Box>
    );
}

export default App;
